import React from 'react'

import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'
import { TrackPositioner } from '../TrackPositioner/TrackPositioner'

interface FloorCameraFeedProps {
  id: number
}

const FloorMobileFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useParticipant(id)

  if (!participant?.tracks.mobile) return null

  return (
    <TrackPositioner trackId={id} trackType="mobile">
      <VideoTrack track={participant.tracks.mobile} />
    </TrackPositioner>
  )
}

export { FloorMobileFeed }
